/** @format */

import $ from "jquery";
import L from "leaflet";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";

import "leaflet/dist/leaflet.css";
import DetailTable from "./DetailTable";
import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";
import Minimap from "../../../../components/map/Minimap";
import { header } from "../../../../components/api/Header";
import { getEnv } from "../../../../lib/env";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const SuvomborlaridetailsSahifa = ({ ombor, setOmbor }) => {
  const params = useParams();
  const [data, setData] = useState([]);
  const [toggle, setToggle] = useState(1);
  const [details, setDetails] = useState("");
  const [omborId, setOmborId] = useState(params.omborId ? params.omborId : 1);
  const [selectedData, setSelectedData] = useState("");
  const [toMap, setToMap] = useState(ombor.location);

  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);

  const tabs = [
    { title: "Texnik ko'rsatgichlar", id: 4, type: "text" },
    { title: "location", id: 1, type: "location" },
  ];

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/suvomborlari", { replace: true });
  };

  const selectOmbor = (d) => {
    setToMap([d.lat, d.lan]);
    navigate("/suvomborlari/" + d.id, { replace: true });
    setOmbor({ nomi: d.nomi, location: [d.lat, d.lan] });
    setOmborId(d.id);
    setSelectedData(d.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios
        .get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/suvombor/index?date=" +
            date,
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
          alert("Bazaga ulanishda xato");
        });
      if (res) {
        setData(res.data);
      }
    };
    if (toggle == 1) {
      fetchData();
    }
  }, [date, toggle]);

  const filterOmbors = (text) => {
    $("#OmborList li").each(function () {
      if ($(this)[0].innerText.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  useEffect(() => {
    const fetchInfo = async () => {
      const res = await axios
        .get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/suvombor/details?date=" +
            date +
            "&omborId=" +
            omborId,
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
          alert("Bazaga ulanishda xato");
        });
      if (res) {
        setDetails(res.data);
      }
    };
    fetchInfo();
  }, [omborId, date]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left suv-omborlari suv-omborlari-details'>
          <li>
            <span onClick={handleClick}> {"<- Suv omborlari"}</span> -{" "}
            {ombor.nomi}
          </li>

          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          <input
            type='date'
            onChange={(e) => setLdate(e.target.value)}
            className='form-control-sm form-control'
            value={ldate}
          />
        </ul>
      </ContentTop>

      <div className='tabs-content table-box details-bg'>
        <div
          className={
            toggle == 4 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <div className=''>
            <div className='container-fluid'>
              <div className='details-content-box'>
                <div className='details-content-box-left'>
                  <DetailTable details={details} />
                </div>
                {details ? images(details.images) : null}
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            toggle === 1 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <div className='details-box'>
            <div className='details-box-left'>
              <input
                type='text'
                prefix={<SearchOutlined className='site-form-item-icon' />}
                placeholder='Kuzatuv stansiyasi'
                className='form-control form-control-sm'
                onChange={(e) => filterOmbors(e.target.value)}
              />
              <ul
                style={{ maxHeight: "75vh", overflow: "auto" }}
                className='pt-2'
                id='OmborList'>
                {data
                  ? data.map((d, i) => {
                      if (d.lat && d.lan) {
                        return (
                          <li
                            key={i}
                            onClick={() => selectOmbor(d)}
                            className='haslatlng'>
                            <button
                              style={{
                                background:
                                  ombor.nomi === d.nomi ? "#0b4aa9" : "",
                                color: ombor.nomi === d.nomi ? "#fff" : "",
                              }}
                              className='sidebar-list'>
                              <table>
                                <tbody>
                                  <tr>
                                    <td>{d.nomi}</td>
                                    <td>{d.data}</td>
                                    <td
                                      style={{
                                        color:
                                          ombor.nomi === d.nomi
                                            ? "#fff"
                                            : "#0b4aa9",
                                      }}>
                                      mln m3
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </button>
                          </li>
                        );
                      } else {
                        return (
                          <li key={i} onClick={() => selectOmbor(d)}>
                            <button
                              style={{
                                background:
                                  ombor.nomi === d.nomi ? "#0b4aa9" : "",
                                color: ombor.nomi === d.nomi ? "#fff" : "",
                              }}
                              className='sidebar-list'>
                              <table>
                                <tbody>
                                  <tr>
                                    <td>{d.nomi}</td>
                                    <td>{d.data}</td>
                                    <td
                                      style={{
                                        color:
                                          ombor.nomi === d.nomi
                                            ? "#fff"
                                            : "#0b4aa9",
                                      }}>
                                      mln m3
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </button>
                          </li>
                        );
                      }
                    })
                  : null}
              </ul>
            </div>

            <div className='details-box-right'>
              <Minimap
                location={toMap}
                zoom={13}
                locations={data}
                onSelectData={selectOmbor}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuvomborlaridetailsSahifa;

const images = (data) => {
  const imgs = data.split(",");

  return (
    <div className='details-content-box-right'>
      {imgs[0] ? (
        <div className='details-img'>
          <img
            src={
              getEnv('REACT_APP_BASE_URL') +
              "/assets/uploads/so/images/" +
              imgs[0]
            }
            alt='404'
          />
        </div>
      ) : null}

      {imgs[1] ? (
        <div className='details-img'>
          <img
            src={
              getEnv('REACT_APP_BASE_URL') +
              "/assets/uploads/so/images/" +
              imgs[1]
            }
            alt='404'
          />
        </div>
      ) : null}
    </div>
  );
};
